import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { ResourceManagerService, ResourceSet } from '@barthauer/abc/core/resources';
import { _AbcButtonComponent } from '@barthauer/abc/ui-components/abc-button';
import { ValuesEditorComponent } from '../values-editor.component';

@Component({
  selector: 'parameters-values-editor-values-editor-container',
  imports: [_AbcButtonComponent, MatTabsModule, ValuesEditorComponent],
  templateUrl: './values-editor-container.component.html',
  styleUrls: ['./values-editor-container.component.scss'],
})
export class ValuesEditorContainerComponent implements OnInit {
  paraDefinitions: any[];
  singleSelectParas: any[];
  multiSelectParas: any[];
  multiSelectParaDefinitions: any[];

  @Output() parameterDialogApplied = new EventEmitter();
  @Output() parameterDialogCancelled = new EventEmitter();
  public resAsync: Promise<ResourceSet>;
  public res = ResourceSet.Empty;

  constructor(private resourceService: ResourceManagerService) {
    this.singleSelectParas = [];
    this.multiSelectParas = [];
    this.multiSelectParaDefinitions = [];
    this.resAsync = this.resourceService.getResourceSet('abc-parameters-values-editor');
  }

  async ngOnInit() {
    this.singleSelectParas = this.getFilteredParaDefinitions(false);
    this.multiSelectParas = this.getFilteredParaDefinitions(true);
    this.multiSelectParaDefinitions = this.getMultiSelectParaDefinitions();
    this.res = await this.resAsync;
  }

  getFilteredParaDefinitions(allowMultiSelect: boolean | null | undefined) {
    return this.paraDefinitions.filter((para) => para.AllowMultiSelect === allowMultiSelect);
  }

  getMultiSelectParaDefinitions() {
    const multiSelectParaDefinitions = [];
    const numMultiSelectParas = this.multiSelectParas.length;

    if (numMultiSelectParas > 0) {
      for (let i = 0; i < numMultiSelectParas; i++) {
        const para = this.multiSelectParas[i];
        const filteredParas = this.getFilteredParaDefinitions(para.AllowMultiSelect);

        multiSelectParaDefinitions.push({ para, filteredParas });
      }
    }
    return multiSelectParaDefinitions;
  }

  parameterValueChanged(p: any) {
    try {
      if (p) {
        for (let para of this.paraDefinitions) {
          if (p.Name === para.Name) para.Value = p.Value;
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  cancel(): void {
    this.parameterDialogCancelled.emit();
  }

  apply(): void {
    this.parameterDialogApplied.emit();
  }
}
